import SideMenu from "./sideMenu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useEffect, useState } from "react";
import config from "../../config";
import { useSelector } from "react-redux";
import QueryString from "query-string";
import { FormControl, InputAdornment, OutlinedInput } from "@material-ui/core";
import { Button, Modal } from "react-bootstrap";
import LogoImage from "../image/Logo_Original.png";
import { otpDuration } from "../../config";
import MaterialTable from "material-table";
import { tableIcons } from "../../tableIcons";
import { TablePagination, Snackbar } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { withRouter } from "../../utils/withRouter";
import { useAccess } from "../../provider/AccessProvider";

const CustomerLoyaltyDetails = (props) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [shopId, setShopId] = useState("");
  const [customerSince, setCustomerSince] = useState("");
  const [previousVisit, setPreviousVisit] = useState("");
  const [totalPointsAdded, setTotalPointsAdded] = useState(0);
  const [totalPointsRedeemed, setTotalPointsRedeemed] = useState(0);
  const [points, setPoints] = useState(0.0);
  // const [pointsRedeem, setPointsRedeem] = useState("");
  const [billAmount, setBillAmount] = useState("");
  const [confirmActionModal, setConfirmActionModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const merchantId = useSelector((state) => state.shopDetails.shopId);
  const loyaltyRatio = useSelector((state) => state.shopDetails.loyaltyRatio);
  const loyaltyExpiryDate = useSelector(
    (state) => state.shopDetails.loyaltyExpiryDate
  );
  const [otpSent, setOtpSent] = useState("");
  const [inputOtp, setInputOtp] = useState("");
  const [otpModal, setOtpModal] = useState(false);
  const [loyaltyCouponsArray, setLoyaltyCouponsArray] = useState([]);
  const [redeemCouponObject, setRedeemCouponObject] = useState({});
  const [couponHistoryObject, setCouponHistoryObject] = useState({});
  const [couponHistoryArray, setCouponHistoryArray] = useState([]);
  const [minutes, setMinutes] = useState();
  const [seconds, setSeconds] = useState();
  const [resendOtpFlag, setResendOtpFlag] = useState(true);
  const [couponHistoryModal, setCouponHistoryModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);
  const [successAddPoint, setSuccessAddPoint] = useState(false);
  const [failureAddPoint, setFailureAddPoint] = useState(false);
  const [loader, setLoader] = useState(false);
  const shopDetails = useSelector((state) => state.shopDetails);
  const access = useAccess(["addPoints", "loyaltyRedeem"]);

  useEffect(() => {
    function keydownHandler(event) {
      event.stopImmediatePropagation();
      if (event.altKey && event.keyCode == 65) {
        // Add points (A)
        document.getElementById("addPoint").click();
      } else if (event.altKey && event.keyCode == 82) {
        // Redeem Coupon (R)
        document
          .getElementById("redeemPoints")
          .scrollIntoView({ behavior: "smooth" });
      } else if (event.altKey && event.keyCode == 72) {
        // Points History (H)
        document
          .getElementById("pointsHistory")
          .scrollIntoView({ behavior: "smooth" });
      }
    }
    document.addEventListener("keydown", keydownHandler, false);
    return () => {
      document.removeEventListener("keydown", keydownHandler, false);
    };
  }, []);

  const addPointsHandler = (value) => {
    if (value === "") {
      setPoints(0.0);
      setBillAmount("");
      return;
    }
    let points = parseFloat(value) / parseFloat(loyaltyRatio);
    setPoints(points.toFixed(1));
    setBillAmount(value);
  };

  useEffect(() => {
    if (loyaltyExpiryDate === "") return;
    if (
      Math.ceil(
        (new Date(loyaltyExpiryDate) - new Date()) / (1000 * 60 * 60 * 24)
      ) < 0
    ) {
      alert("Loyalty package Expired");
      props.history.push("/dashboard/loyalty");
    }
  }, [loyaltyExpiryDate]);

  useEffect(() => {
    if (merchantId === "") return;
    let params = QueryString.parse(props.location.search);
    setPhoneNumber(`${shopDetails.country.dialCode}${params.id}`);
    setShopId(merchantId);
  }, [merchantId]);

  const fetchLoyaltyByCustomers = async () => {
    if (shopId === "") return;
    if (phoneNumber === "") return;
    await Promise.all([
      fetch(`${config.newApiGateway}/loyalty/customerLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopId,
          action: "fetchLoyaltytbycustomer",
          userPhoneNumber: `${phoneNumber}`,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        let sortedArr = data.sort((d1, d2) => {
          if (new Date(d1.transactionDate) < new Date(d2.transactionDate))
            return 1;
          if (new Date(d1.transactionDate) > new Date(d2.transactionDate))
            return -1;
          return 0;
        });
        let customerSince = sortedArr[sortedArr.length - 1].transactionDate;
        let previousVisit = sortedArr[0].transactionDate;
        setCustomerSince(customerSince);
        setPreviousVisit(previousVisit);
        getCustomerDetails();
        setLoyaltyData(data);
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const getCustomerDetails = async () => {
    await Promise.all([
      fetch(`${config.newApiGateway}/customer/getCustomerDetailswithLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          phoneNumber: `${phoneNumber}`,
          shopId: shopId,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        // console.log("dataqq", data);
        if (data.customerName !== null) {
          setCustomerName(data.customerName);
        } else {
          setCustomerName("NA");
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const fetchLoyaltyCoupon = async () => {
    if (shopId === "") return;
    await Promise.all([
      fetch(`${config.newApiGateway}/loyalty/loyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopId,
          action: "fetchLoyaltyCoupon",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setLoyaltyCouponsArray(data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchLoyaltyByCustomers();
    fetchLoyaltyCoupon();
  }, [shopId, phoneNumber]);

  useEffect(() => {
    processLoyaltyData();
  }, [loyaltyData]);

  const processLoyaltyData = () => {
    let tempTotalAdded = 0;
    let tempTotalRedeemed = 0;

    loyaltyData.map((data) => {
      if (data.pointsAction === "added") {
        tempTotalAdded += parseFloat(data.points) || 0;
      }
      if (data.pointsAction === "redeemed") {
        tempTotalRedeemed += parseFloat(data.points) || 0;
      }
    });
    setTotalPointsAdded(tempTotalAdded);
    setTotalPointsRedeemed(tempTotalRedeemed);
  };

  const addLoyaltyPoints = async () => {
    setLoader(true);
    await Promise.all([
      fetch(`${config.newApiGateway}/loyalty/customerLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          points: points,
          shopId: shopId,
          userPhoneNumber: phoneNumber,
          amount: billAmount,
          action: "addLoyalty",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setPoints(0);
        setBillAmount("");
        setConfirmActionModal(false);
        setModalText("");
        fetchLoyaltyByCustomers();
        // setPointsRedeem("");
        setSuccessAddPoint(true);
      })
      .catch((err) => {
        console.log("Err", err);
        setFailureAddPoint(true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const sendOtp = async () => {
    let otp = Math.floor(100000 + Math.random() * 900000);
    setOtpSent(otp.toString());
    await Promise.all([
      fetch(`${config.newApiGateway}/loyalty/customerLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          otp: otp,
          userPhoneNumber: phoneNumber,
          action: "sentOtpToCustomer",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setOtpModal(true);
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const verifyOtp = () => {
    if (inputOtp === "") return alert("Enter Valid OTP.");
    if (otpSent !== inputOtp) {
      return alert("Invalid OTP. Please Enter valid OTP");
    }
    redeemLoyaltyCoupon();
    setInputOtp("");
    setOtpModal(false);
  };

  const redeemLoyaltyCoupon = async () => {
    await Promise.all([
      fetch(`${config.newApiGateway}/redeemLoyaltyCoupon`, {
        method: "POST",
        body: JSON.stringify({
          couponId: redeemCouponObject.couponId,
          shopId: shopId,
          userPhoneNumber: phoneNumber,
          pinCode: redeemCouponObject.pincode,
          couponDetails: redeemCouponObject.couponDetails,
          points: redeemCouponObject.minLoyaltyPointsReq,
          action: "redeemLoyaltyCoupon",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setRedeemCouponObject({});
        setInputOtp("");
        setOtpModal(false);
        fetchLoyaltyByCustomers();
        setMinutes();
        setSeconds();
        setSuccess(true);
      })
      .catch((err) => {
        console.log("Err", err);
        setFailure(true);
      });
  };

  const otpTimer = () => {
    var timer = otpDuration,
      minutes,
      seconds;

    var interval = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      setMinutes(minutes);
      setSeconds(seconds);

      if (--timer < 0) {
        setResendOtpFlag(false);
        clearInterval(interval);
      }
    }, 1000);
  };

  const fetchLoyaltyCouponHistory = async (data) => {
    setCouponHistoryObject(data);
    await Promise.all([
      fetch(`${config.newApiGateway}/loyalty/loyalty`, {
        method: "POST",
        body: JSON.stringify({
          couponId: data.couponId,
          shopId: shopId,
          action: "fetchLoyaltyCouponHistorybyid",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setCouponHistoryArray(data);
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const onClose = () => {
    setSuccess(false);
    setFailure(false);
    setSuccessAddPoint(false);
    setFailureAddPoint(false);
  };

  function PatchedPagination(props) {
    const {
      ActionsComponent,
      onChangePage,
      onChangeRowsPerPage,
      ...tablePaginationProps
    } = props;
    return (
      <TablePagination
        {...tablePaginationProps}
        // @ts-expect-error onChangePage was renamed to onPageChange
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        ActionsComponent={(subprops) => {
          const { onPageChange, ...actionsComponentProps } = subprops;
          return (
            // @ts-expect-error ActionsComponent is provided by material-table
            <ActionsComponent
              {...actionsComponentProps}
              onChangePage={onPageChange}
            />
          );
        }}
      />
    );
  }

  return (
    <>
      <div>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <div>
              <div>
                <p>Total Points Available</p>
                <h1 style={{ lineHeight: "50%" }}>
                  {(
                    parseFloat(totalPointsAdded) -
                    parseFloat(totalPointsRedeemed)
                  ).toFixed(1)}
                </h1>
              </div>
            </div>
            <div style={{ margin: "20px", width: "20%" }}>
              <div>
                <p>Customer Name</p>
                <h3 style={{ lineHeight: "50%" }}>{customerName}</h3>
              </div>
            </div>
            <div style={{ margin: "20px", width: "20%" }}>
              <div>
                <p>Phone Number</p>
                <h4 style={{ lineHeight: "50%" }}>{phoneNumber}</h4>
              </div>
            </div>
            <div style={{ margin: "20px", width: "20%" }}>
              <div>
                <p>Customer Since</p>
                <h3 style={{ lineHeight: "50%" }}>{customerSince}</h3>
              </div>
            </div>
            <div style={{ margin: "20px", width: "20%" }}>
              <div>
                <p>Previous Visit</p>
                <h3 style={{ lineHeight: "50%" }}>{previousVisit}</h3>
              </div>
            </div>
            <div style={{ margin: "20px", width: "20%" }}>
              <div>
                <p>Total Points Redeemed</p>
                <h3 style={{ lineHeight: "50%" }}>
                  {parseFloat(totalPointsRedeemed).toFixed(1)}
                </h3>
              </div>
            </div>
            <div style={{ margin: "20px", width: "20%" }}>
              <div>
                <p>Overall Points Earned</p>
                <h1 style={{ lineHeight: "50%" }}>
                  {parseFloat(totalPointsAdded).toFixed(1)}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="loyaltyAddRedeem">
          <div className="loyaltyAddPoints">
            <h4 style={{ margin: "20px" }}>Add Points</h4>
            <div style={{ display: "flex" }}>
              <div style={{ margin: "20px" }}>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: "250px" }}
                >
                  <OutlinedInput
                    placeholder="Enter bill Amount"
                    onChange={(e) => addPointsHandler(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        Points: {points}
                      </InputAdornment>
                    }
                    value={billAmount}
                    type="number"
                    labelWidth={0}
                  />
                </FormControl>
              </div>
              <div style={{ margin: "20px 20px 20px 0px" }}>
                <Button
                  id="addPoint"
                  variant="outline-danger"
                  onClick={() => {
                    const isAccess = access.addPoints();
                    if (!isAccess) {
                      return;
                    }
                    if (billAmount === "") return alert("Enter Bill Amount");
                    setConfirmActionModal(!confirmActionModal);
                    setModalText(
                      `For ${billAmount} you are adding ${points} points.`
                    );
                  }}
                >
                  Add Points
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="loyaltyRedeemCoupon">
          <h4 style={{ margin: "20px", paddingTop: "20px" }}>Redeem Coupon</h4>
          <div className="loyaltyCouponCard">
            {loyaltyCouponsArray.map((data) => (
              <div className="couponCardStyle" key={data.couponId}>
                <div className="inCardStyle">
                  <div
                    style={{
                      width: "30%",
                      textAlign: "center",
                      fontSize: "14px",
                      backgroundColor: "#0dcaf0",
                      paddingTop: "12px",
                      color: "white",
                      borderRadius: "5px 0px 0px 5px",
                    }}
                  >
                    USE {data.minLoyaltyPointsReq} LOYALTY POINTS
                  </div>
                  <div
                    style={{
                      height: "85px",
                      border: "2px dotted black",
                    }}
                  ></div>
                  <div style={{ width: "70%", margin: "5px" }}>
                    <p>{data.couponDetails}</p>
                    <p
                      style={{
                        float: "left",
                        marginTop: "-10px",
                        fontSize: "12px",
                        textDecoration: "underline",
                        cursor: "pointer",
                        color: "blue",
                      }}
                      onClick={() => {
                        setCouponHistoryModal(true);
                        fetchLoyaltyCouponHistory(data);
                      }}
                    >
                      History
                    </p>
                    <Button
                      id="redeemPoints"
                      disabled={
                        parseFloat(data.minLoyaltyPointsReq) >
                        parseFloat(totalPointsAdded) -
                          parseFloat(totalPointsRedeemed)
                          ? true
                          : false
                      }
                      variant="outline-info"
                      size="sm"
                      style={{
                        marginTop: "-15px",
                        // marginLeft: "65%",
                        float: "right",
                        marginBottom: "20px",
                      }}
                      onClick={() => {
                        if (!access.loyaltyRedeem(false)) {
                          alert(
                            "You do not have access to this feature. Please contact your administrator to request the appropriate access."
                          );
                          return;
                        }
                        setRedeemCouponObject(data);
                        sendOtp();
                        otpTimer();
                      }}
                    >
                      Redeem
                    </Button>
                  </div>
                </div>
                <div></div>
              </div>
            ))}
          </div>
        </div>
        <div className="customerLoyaltyHistory" id="pointsHistory">
          <h3 style={{ paddingTop: "10px", margin: "20px" }}>Points History</h3>
          <div className="pointsHistoryCards">
            {loyaltyData.map((data, i) => (
              <div className="historyCardStyle" key={i}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <h1>{data.points}</h1>
                  <h6>Points {data.pointsAction}</h6>
                  <h5 className="text-muted">{data.transactionDate}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
        {success && (
          <Snackbar open={success} autoHideDuration={4000} onClose={onClose}>
            <Alert onClose={onClose} severity="success">
              <AlertTitle>Success</AlertTitle>
              Loyalty Coupon Redeemed Successfully.
            </Alert>
          </Snackbar>
        )}
        {failure && (
          <Snackbar open={failure} autoHideDuration={4000} onClose={onClose}>
            <Alert onClose={onClose} severity="success">
              <AlertTitle>Failed</AlertTitle>
              Error while Redeeming Loyalty Coupon. Please Try Again.
            </Alert>
          </Snackbar>
        )}
        {successAddPoint && (
          <Snackbar
            open={successAddPoint}
            autoHideDuration={4000}
            onClose={onClose}
          >
            <Alert onClose={onClose} severity="success">
              <AlertTitle>Success</AlertTitle>
              Loyalty Points Added Successfully.
            </Alert>
          </Snackbar>
        )}
        {failureAddPoint && (
          <Snackbar
            open={failureAddPoint}
            autoHideDuration={4000}
            onClose={onClose}
          >
            <Alert onClose={onClose} severity="success">
              <AlertTitle>Failed</AlertTitle>
              Error while Adding Loyalty Points. Please Try Again.
            </Alert>
          </Snackbar>
        )}
      </div>
      <Modal show={confirmActionModal}>
        <Modal.Body>
          <h4>{modalText}</h4>
          <h5>Are you sure?</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={loader}
            onClick={() => addLoyaltyPoints()}
            variant="outline-success"
          >
            Yes
          </Button>
          <Button
            variant="outline-danger"
            onClick={() => setConfirmActionModal(!confirmActionModal)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={otpModal}>
        <Modal.Body style={{ textAlign: "center" }}>
          <div>
            <img
              style={{
                display: "inline",
                width: "250px",
                height: "80px",
                margin: "20px",
              }}
              src={LogoImage}
              alt="logo"
            />
          </div>
          <h5>Enter OTP Sent to {phoneNumber}</h5>
          <input
            onChange={(e) => setInputOtp(e.target.value)}
            placeholder="Enter OTP"
            value={inputOtp}
            style={{
              margin: "20px",
            }}
          />
          <br />
          <button
            disabled={resendOtpFlag}
            style={{
              margin: "10px",
              color: "red",
              cursor: "pointer",
              backgroundColor: "white",
              border: "none",
            }}
            onClick={() => {
              setMinutes();
              setSeconds();
              setResendOtpFlag(false);
              setInputOtp("");
              otpTimer();
              sendOtp();
            }}
          >
            Resend OTP {minutes}:{seconds}
          </button>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => verifyOtp()} variant="outline-success">
            Submit
          </Button>
          <Button
            variant="outline-danger"
            onClick={() => setOtpModal(!otpModal)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={couponHistoryModal}
        onHide={() => {
          setCouponHistoryModal(!couponHistoryModal);
          setCouponHistoryObject({});
        }}
        dialogClassName="loyaltyHistoryCustomModal"
      >
        <Modal.Header>
          <h3>Coupon Details</h3>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <p>Coupon Name</p>
              <h3>{couponHistoryObject.couponDetails}</h3>
            </div>
            <div style={{ textAlign: "center" }}>
              <p>Created Date</p>
              <h3>{couponHistoryObject.addedDate}</h3>
            </div>
          </div>
          <div style={{ margin: "20px" }}>
            <MaterialTable
              data={couponHistoryArray}
              columns={[
                {
                  title: "Customer Mobile number",
                  field: "userPhoneNumber",
                },
                {
                  title: "Points Redeemed",
                  render: () => {
                    return <>{couponHistoryObject.minLoyaltyPointsReq}</>;
                  },
                },
                {
                  title: "Redeemed Date",
                  field: "redeemedDate",
                },
              ]}
              icons={tableIcons}
              components={{
                Pagination: PatchedPagination,
              }}
              title="Coupon History"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setCouponHistoryModal(!couponHistoryModal);
              setCouponHistoryObject({});
            }}
            variant="outline-warning"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withRouter(CustomerLoyaltyDetails);
